<script>
  import { MainForm, store, imgSrc } from '$client';
  const { city } = store;
  export let data;
</script>

<section id="main">
  <section class="container contact-block">
    <h1 class="h1">Контакты</h1>
    <address>
      {#each $city.block as address}
        <div>
          <img src={imgSrc(address.img.data.attributes.url)} alt={address.img.data.attributes.alternativeText} />
          {#if address.href}
            <a class="color-button" href={address.href}>{address.header}</a>
          {:else}
            <p>{address.header}</p>
          {/if}
        </div>
      {/each}
    </address>
  </section>
  <section class="container" id="map">
    <h2 class="h2">{$city.ymap.header}</h2>
    {@html $city.ymap.iframe}
  </section>
  <section class="container margin-block" id="requisite">
    <h2 class="h2">{data.contactPage.requisites.header}</h2>
    <address>{@html data.contactPage.requisites.data.replaceAll('\n', '<br/>')}</address>
  </section>
  <MainForm data={data.contactPage.form.data.attributes} />
</section>

<style lang="scss">
  #main {
    position: relative;
  }

  section {
    display: flex;
    flex-direction: column;
  }

  h1,
  h2 {
    padding-bottom: 30px;
    color: #2c333c;
    font-weight: 800;
    font-size: 30px;
    font-family:
      Vela Sans,
      sans-serif;
    line-height: 45px;

    @media only screen and (max-width: 991.98px) {
      padding-bottom: 20px;
      font-size: 25px;
    }

    @media only screen and (max-width: 767.98px) {
      padding-bottom: 25px;
    }

    @media only screen and (max-width: 551px) {
      padding-bottom: 10px;
    }
  }

  address {
    color: #2c333c;
    font-weight: normal;
    font-size: 18px;
    font-family: Roboto, sans-serif;
    line-height: 25px;

    @media only screen and (max-width: 551px) {
      font-size: 16px;
    }

    @media only screen and (max-width: 393px) {
      font-size: 14px;
    }
  }

  #map {
    width: 100%;
  }

  .contact-block {
    width: 100%;
    font-size: 18px;
    font-family: Roboto;
    padding-block: 50px;

    h1 {
      color: #2c333c;
      font-weight: 800;
      font-size: 36px;
      font-family: Vela Sans;
    }

    address {
      display: inline-flex;
      flex-wrap: wrap;
      gap: 24px;
      width: 100%;

      div {
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 12px;
        align-items: center;
        justify-content: center;
        color: #2c333c;
      }

      a {
        color: #2c333c;
      }
    }
  }
</style>
